import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';
import {PromoCode, PromoType} from '@domain/model/PromoCode/PromoCode';

const GetUrlPromoCode = (repository: StoragePromoCodeRepository) => async (): Promise<PromoCode | null> => {
  const value = await repository.getPromoUrl();
  return value ? {value, type: PromoType.URL} : null;
};

export {GetUrlPromoCode};
